"use client";

import React, { PropsWithChildren } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import clsx from "classnames";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";

import ThemeWrapper from "@/components/Theme/ThemeWrapper";

import { queryClient } from "@/utils/queryClient";
import { useAppTheme } from "@/utils/hooks/useAppTheme";
import customBashHighlights from "@/utils/customBashHighlights";

// Register the custom syntax highlighting so it’s available across all components
SyntaxHighlighter.registerLanguage("bash", customBashHighlights);

const RootLayoutWrapper = ({ children }: PropsWithChildren) => {
  const { theme: appTheme } = useAppTheme();
  return (
    <QueryClientProvider client={queryClient}>
      <body
        className={clsx({
          "dark-content": appTheme === "dark",
        })}
      >
        <ThemeWrapper>{children}</ThemeWrapper>
        <Toaster />
        <ReactQueryDevtools initialIsOpen={false} />
      </body>
    </QueryClientProvider>
  );
};

export default RootLayoutWrapper;
